import { ArrowRight, Phone, Star } from "lucide-react";
import { TID } from "@/constants/testIds";

const HERO_BG = "https://images.pexels.com/photos/36288084/pexels-photo-36288084.jpeg";

export const Hero = ({ rating }) => {
  return (
    <section className="relative min-h-[100vh] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${HERO_BG}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-black" />
      <div className="absolute inset-0 grain" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 pt-56 pb-20 w-full">
        <div className="max-w-3xl fade-up">
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-white leading-[1.05]">
            Clean Spaces.
            <br />
            <span className="gold-grad-text">Elevated Standards.</span>
          </h1>
          <p className="mt-8 text-lg lg:text-xl text-white/70 max-w-xl leading-relaxed">
            Commercial, move-in/move-out, and post-construction cleaning — delivered with precision, discretion, and zero shortcuts.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href="#quote" data-testid={TID.heroCta} className="btn-gold pulse-gold">
              Request a Free Quote <ArrowRight size={18} strokeWidth={1.5} />
            </a>
            <a href="tel:7573542290" data-testid={TID.heroCall} className="btn-ghost">
              <Phone size={16} strokeWidth={1.5} /> 757-354-2290
            </a>
          </div>

          {rating && rating.count > 0 && (
            <div className="mt-10 flex items-center gap-4 text-white/80">
              <div className="flex items-center">
                {[1,2,3,4,5].map((i) => (
                  <Star
                    key={i}
                    size={18}
                    strokeWidth={0}
                    fill={i <= Math.round(rating.average) ? "#D4AF37" : "#3a3a3a"}
                  />
                ))}
              </div>
              <div className="text-sm">
                <span className="text-white font-medium">{rating.average.toFixed(1)}</span>
                <span className="text-white/50"> · {rating.count} verified review{rating.count === 1 ? "" : "s"}</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="absolute bottom-8 inset-x-0 flex justify-center z-10">
        <div className="text-white/40 text-xs tracking-[0.3em] uppercase animate-pulse">Scroll</div>
      </div>
    </section>
  );
};
